import { NotifyPartyService } from './notify-party.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { NotifyPartyDTO } from './dto/notify-party.dto';
import { AllNotifyPartyResponse, CommonResponse, NotifyPartyDto, NotifyPartyResponse } from '@gtpl/shared-models/masters';
import { NotifyPartyRequest } from './dto/notify-party.request';
import { NotifyParty } from './notify-party.entity';
import { UserRequestDto } from '../countries/dto/user-request-dto';
// import { UserRequestDto } from '@gtpl/shared-models/common-models';

@Controller('notify-party')
export class NotifyPartyController {
    constructor(
        private notifyPartyService: NotifyPartyService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ) { }
    /**
     * creates  a Notify Party
     * @param NotifyPartyDto NotifyParty DTO
     * @returns  NotifyPartyResponse
     */
    @Post('/createNotifyParty')
    async createNotifyParty(@Body() notifyPartyDTO: NotifyPartyDTO): Promise<NotifyPartyResponse> {
        try {
            return await this.notifyPartyService.createNotifyParty(notifyPartyDTO, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(NotifyPartyResponse, error);
        }
    }
    /**
     * gets all the Value Notify Party
     * @returns AllNotifyPartyResponse which returns all the Value notify-Party  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */
    @Post('/getAllNotifyParty')
    async getAllNotifyParty(@Body() req?:UserRequestDto): Promise<AllNotifyPartyResponse> {
        try {
            return await this.notifyPartyService.getAllNotifyParty(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllNotifyPartyResponse, error);
        }
    }

    /**
   * Activate Or De-Activate Value NotifyParty
   * @param getSingleNotifyParty NotifyParty
   * @returns Value NotifyParty
   */
    @Post('/activateOrDeactivateNotifyParty')
    async activateOrDeactivateNotifyParty(@Body() notifyPartyReq: NotifyPartyRequest): Promise<NotifyPartyResponse> {
        try {
            return await this.notifyPartyService.activateOrDeactivateNotifyParty(notifyPartyReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(NotifyPartyResponse, err);
        }
    }
    /**
  *  updates a  value Notify Party
  * @param NotifyPartyDto Notify Party DTO
  * @returns NotifyPartyResponse
  */
     @Post('/updateNotifyParty')
     async updateNotifyParty(@Body() notifyPartyDTO:NotifyPartyDTO): Promise<NotifyPartyResponse> {
         try {
          return await this.notifyPartyService.createNotifyParty(notifyPartyDTO,true);
        } catch (error) {
             return this.applicationExceptionHandler.returnException(NotifyPartyResponse, error);
        }
      }
      @Post('/getAllNotifyPartyDropDown')
      async getAllNotifyPartyDropDown():Promise<CommonResponse>{
         try {
             return await this.notifyPartyService.getAllNotifyPartyDropDown();
         } catch (err) {
             return this.applicationExceptionHandler.returnException(CommonResponse, err);
         }
      }
 
    //   @Post('/getNotifyPartyInfoById')
    //   async getNotifyPartyById(@Body() notifyPartyReq: NotifyPartyRequest):Promise<NotifyParty>{
    //      try {
    //          return await this.notifyPartyService.getNotifyPartyById(notifyPartyReq.notifyPartyId);
    //      } catch (err) {
    //         return err;
    //      }
    //    }
       
       @Post('/getNotifyPartyInfoById')
     async getNotifyPartyInfoById(@Body() notifyPartyReq: NotifyPartyRequest):Promise<NotifyPartyResponse>{
        try {
            return await this.notifyPartyService.getNotifyPartyInfoById(notifyPartyReq);
        } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
      }
}
